module.exports = __webpack_public_path__ + "img/Frame-78.be001bbd.svg";